import React from 'react';
import { LngLat, Map, MapboxGeoJSONFeature, Popup } from 'mapbox-gl';
import { OrderPopup } from 'pages/planner/map/popup/OrderPopup';
import { geoJsonPropertiesToPlannerOrder } from 'pages/planner/map/utils/mapUtils';
import { render } from 'react-dom';
import { PlannerOrder, WindowGroups } from 'pages/planner/utils/usePlannerData';
import { BundleJson } from 'types/bundleTypes';

export const MapMarkerPopup = (
  map: Map,
  features: MapboxGeoJSONFeature[],
  langLat: LngLat,
  popupRef: Popup,
  selectedOrderIds: string[],
  windowGroups: WindowGroups,
  fetchedBundles: BundleJson[],
  onSelect: (orders: PlannerOrder[]) => void,
  title?: string
) => {
  const coordinates = (features[0].geometry as any).coordinates.slice();
  const orders = geoJsonPropertiesToPlannerOrder(features[0].properties);

  // Ensure that if the map is zoomed out such that
  // multiple copies of the feature are visible, the
  // popup appears over the copy being pointed to.
  while (Math.abs(langLat.lng - coordinates[0]) > 180) {
    coordinates[0] += langLat.lng > coordinates[0] ? 360 : -360;
  }

  /* Popup Content */
  const node = document.createElement('div');
  render(
    <OrderPopup
      title={title}
      orders={orders}
      selectedOrderIds={selectedOrderIds}
      windowGroups={windowGroups}
      fetchedBundles={fetchedBundles}
      callback={(order: PlannerOrder[]) => onSelect(order)}
    />,
    node
  );

  popupRef.setLngLat(coordinates).setDOMContent(node).addTo(map);
};
